export default __webpack_public_path__ + "static/media/03_Business-Portrait-EschweilerPhotography_21A0022.d78d7f3d.jpg";